'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CrossS } from '@lichtblick/photon/icons/symbols/cross-s';
import { useTracker } from '@lichtblick/tracker';
import { useCallback, useEffect, useState } from 'react';
import { isDayOfService, isTimeOfService } from './OToast.helpers';
import styles from './o-toast.module.scss';
export const SectionWithDisplayHandling = ({ children, office_hour_end, office_hour_start, out_of_office, time_to_show })=>{
    const [isHidden, setIsHidden] = useState(true);
    const { trackCustomEvent } = useTracker();
    const trackEvent = useCallback(()=>{
        trackCustomEvent({
            eventName: 'hotline_teaser_impression'
        });
    }, [
        trackCustomEvent
    ]);
    useEffect(()=>{
        const toastTimeout = (time_to_show === '0' ? 0 : Number(time_to_show) || 120) * 1000;
        const shouldShowToast = isDayOfService(out_of_office?.value ?? []) && isTimeOfService(office_hour_start ? Number(office_hour_start) : 8, office_hour_end ? Number(office_hour_end) : 16);
        if (shouldShowToast) {
            setTimeout(()=>{
                setIsHidden(false);
                trackEvent();
            }, toastTimeout);
        }
    }, [
        office_hour_end,
        office_hour_start,
        out_of_office,
        time_to_show,
        trackEvent
    ]);
    return isHidden ? null : /*#__PURE__*/ _jsx("section", {
        className: styles.section,
        "data-testid": "toast",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.wrapper,
            children: [
                /*#__PURE__*/ _jsx("button", {
                    "aria-label": "Schließen",
                    className: styles['close-button'],
                    onClick: ()=>setIsHidden(true),
                    type: "button",
                    children: /*#__PURE__*/ _jsx(CrossS, {})
                }),
                children
            ]
        })
    });
};

//# sourceMappingURL=section-with-display-handling.js.map